export default {
	name: 'ឈ្មោះ',
	gender: 'ភេទ',
	dob: 'ថ្ងៃខែ​ឆ្នាំ​កំណើត',
	phone: 'ទូរស័ព្ទ',
	new_patient: 'អ្នកជម្ងឺថ្មី',
	update_patient: 'កែប្រែអ្នកជំងឺ'
};
